type SnowplowSettings = {
  appId: string;
  trackerName: string;
};
export const SNOWPLOW_SETTINGS: SnowplowSettings = {
  appId: 'montu.pms',
  trackerName: 'hoc.montu-web/apps/pms',
};
